export default "__VITE_ASSET__21227121__"